<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['GS']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo().AT < 4">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}}</span>
                                <customtreeselect :multiple="false"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol' v-if="checkModuleAccess2(constAccessType.view) || (getUserInfo().AT == 4 && getUserInfo().IOL)">
                                <span class='searchLabel'>{{this.getLanguage['GL']['OGT']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :load-options="loadSubBrandOptions"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchOutlet"
                                            :disabled="disableSubDD"
                                            @input="selectOutletOptions" />
                            </div>
                            <div class='searchCol' v-if="getUserInfo().AT < 4">
                                <label class='searchLabel'>{{this.getLanguage['MEM']['MTI']}}</label>
                                <treeselect :multiple="false"
                                            :load-options="loadMemberTypeOptions"
                                            :options="ddMemberTypeList"
                                            :auto-load-root-options="convertToBool(searchMemberType)"
                                            @input="selectMemberType"
                                            :disabled="disableMemDD"
                                            :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                            v-model="searchMemberType" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="GetSetting()" class='searchBtn' ref="search" size="sm" block color="success" @click="GetSetting()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div id="GSDU">
                <div class="table-wrapper p-0 pt-4 pb-2" v-show="!rendering">
                    <CRow class="mx-0">
                        <CCol col="12" v-if="!noData">
                            <strong class="float-left">{{this.getLanguage['DM']['S']}}<span class="gsetting-title">{{settingTitle}}</span></strong> <CButton v-if="checkModuleAccess3(constAccessType.edit)" class='searchBtn float-right' size="sm" color="info" @click="SaveSetting()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                        </CCol>

                        <template v-if="!noData" v-for="(data,index) in settingList">
                            <!--TOTAL NET WINNING-->
                            <template v-if="data.SN == 'TNW'">
                                <CCol col="12" v-if="data.CN">
                                    <h6 class="card-title section-title2">
                                        <span></span> {{renderCategory(data.GCI)}}
                                        <div class="custom_tooltip" style="padding-left:5px;">
                                            <i class="fa fa-question-circle"></i>
                                            <div class="tooltiptext2">{{getLanguage["HELP"]["TNW"]}}</div>
                                        </div>
                                    </h6>
                                </CCol>
                                <CCol col="3" class="mb-2" v-if="arr_currencies.includes(data.CI)">
                                    <CInput class="gsetting-field col-sm-7 input-group-sm px-0"
                                            size="sm" horizontal
                                            :placeholder="settingList[index].FSV === '' ? '' : `${getLanguage['GS'][settingList[index].SettingHierarchy]}(${ThousandSeparator(settingList[index].FSV, CheckIsThousandCurrency(data.CS,this) ? 3 : 2)})`"
                                            :label="data.ISOC"
                                            :value="(settingList[index].SV === '' || settingList[index].SV === null) ? '' : ThousandSeparator(settingList[index].SV, CheckIsThousandCurrency(data.CS,this) ? 3 : 2)"
                                            @change="event => { settingList[index].SV = RemoveThousandSeparator(event, CheckIsThousandCurrency(data.CS,this) ? 3 : 2) }"
                                            min="0.0" step="0.1" />                                    
                                </CCol>
                            </template>


                            <!--Category Items Title + Max Win Multiplier -->
                            <template v-else-if="data.SN == 'MWM'">
                                <CCol col="12" @click="DisplayGCI(data.GCI)" v-if="data.CN">
                                    <h6 class="card-title section-title2"><span></span>{{renderCategory(data.GCI)}} <i :class="arr_displayGCI.includes(data.GCI) ? 'chevron-container chevron-up' : 'chevron-container chevron-down'"></i> </h6>
                                </CCol>

                                <template v-if="arr_displayGCI.includes(data.GCI) && data.GPI == 0 && ( data.SVT==0 || data.SVT==2 )">
                                    <div class="col-sm-4 form-group form-row">
                                        <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName(data.SN, data.GPI)}}</label>
                                        <input class="form-control form-control-sm col-sm-6"
                                               :placeholder="settingList[index].FSV === '' ? '' : `${getLanguage['GS'][settingList[index].SettingHierarchy]}(${ThousandSeparator(settingList[index].FSV, 0)})`"
                                               required
                                               :value="(settingList[index].SV === '' || settingList[index].SV === null) ? '' : ThousandSeparator(settingList[index].SV, 0)"
                                               @change="event => { settingList[index].SV = RemoveThousandSeparator(event.target.value, 0)}"
                                               min="0.0" step="0.1" />
                                    </div>
                                    <div class="custom_tooltip" style="padding-left:5px;">
                                        <i class="fa fa-question-circle"></i>
                                        <span class="tooltiptext2">{{getLanguage["HELP"]["SMWA"]}}</span>
                                    </div>
                                </template>
                            </template>

                            <template v-else-if="(data.SN == 'OF')">
                                <template v-if="arr_displayGCI.includes(data.GCI)">
                                    <div class="gsetting-lblprovider col-sm-12 mb-2" v-if="!data.ISOC">
                                        <span @click="DisplayGPI(data.GPI)" class="pointer" v-if="data.GPI === 4">{{ renderProviderName('AFB1188') }}</span>
                                        <span @click="DisplayGPI(data.GPI)" class="pointer" v-else-if="data.GPI === 139">{{ renderProviderName(data.PN) }}</span>
                                        <span @click="DisplayGPI(data.GPI)" class="pointer" v-else>{{ renderProviderName(data.PN) }}</span>

                                        <template v-if="data.GPI===23">
                                            <div class="custom_tooltip" style="padding-left:5px;">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="tooltiptext2">{{getLanguage["GL"]["CQ9S"]}}</span>
                                            </div>
                                        </template>
                                    </div>

                                    <template v-if="arr_displayGPI.includes(data.GPI) && data.GPI != 0 && (data.SVT==1)">
                                        <!--OnOff-->
                                        <div class="col-sm-4 form-group form-row pb-2">
                                            <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName(data.SN, data.GPI)}}</label>
                                            <div class="col-sm-6 input-group-sm">
                                                <treeselect :multiple="false"
                                                            :options="onOffOptionList"
                                                            :placeholder="settingList[index].FSV === '' ? '' : `${getLanguage['GS'][settingList[index].SettingHierarchy]}(${settingList[index].FSV === '1' ?  getLanguage['GS']['ON'] :  getLanguage['GS']['OFF']})`"
                                                            required
                                                            v-model="settingList[index].SV" />
                                            </div>
                                        </div>
                                        <!--AFB1188 SportList-->
                                        <template v-for="(setting, idx) in settingList" v-if="setting.SN === 'AfbSports' && data.GPI === 4 && selectedSports[setting.GPI]">
                                            <div class="col-sm-4 form-group form-row pb-2">
                                                <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName('SportList', setting.GPI)}}<span class="required" /></label>
                                                <div class="col-sm-6 input-group-sm">
                                                    <treeselect :multiple="true"
                                                                :options="afbSports"
                                                                :placeholder="setting.FSV === '' ? '' :  `${getLanguage['GS'][setting.SettingHierarchy]}(${setting.FSV.split(',').length})`"
                                                                required
                                                                :limit="1"
                                                                :limitText="count => `+${count}`"
                                                                v-model="selectedSports[setting.GPI].selections" />
                                                </div>
                                            </div>
                                        </template>

                                        <div class="col-sm-12 mb-4">
                                            <!--AFB1188 & GGCS-->
                                            <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px;border-bottom:0px">
                                                <template v-for="item in dd_gp_currency['AFB1188']" v-if="data.GPI === 4">
                                                    <button :class="(selectedGP == data.GPI && selectedISOC == item)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGP = data.GPI;selectedISOC = item">{{ item }}</button>
                                                </template>
                                                <template v-for="item in dd_gp_currency[data.PN]" v-if="data.GPI === 139">
                                                    <button :class="(selectedGP == data.GPI && selectedISOC == item)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGP = data.GPI;selectedISOC = item">{{ item }}</button>
                                                </template>
                                                <template v-for="item in dd_gp_currency[data.PN]" v-if="data.GPI !== 4 && data.GPI !== 139">
                                                    <button :class="(selectedGP == data.GPI && selectedISOC == item)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGP = data.GPI;selectedISOC = item">{{ item }}</button>
                                                </template>
                                            </div>

                                            <!--Bet Limit-->
                                            <div class="card tab-content p-2" v-if="selectedGP == data.GPI">
                                                <div class="row">
                                                    <template v-for="(data2,index2) in settingList" v-if="(selectedGP == data2.GPI && selectedISOC == data2.ISOC)  && arr_displayGCI.includes(data2.GCI) && arr_displayGPI.includes(data2.GPI) && (arr_currencies.length==0 || arr_currencies.includes(data2.CI) || data2.SVT==1)">
                                                        <template>
                                                            <template v-if="data2.GPI != 0 && ( data2.SVT==0 || data2.SVT==2 )">
                                                                <div class="col-sm-3 form-group form-row">
                                                                    <label class="col-form-label col-sm-6 col-form-label-sm">{{RenderSettingName(data2.SN, data2.GPI)}}</label>
                                                                    <input class="form-control form-control-sm col-sm-6"
                                                                           :placeholder="settingList[index2].FSV === '' ? '' : `${getLanguage['GS'][settingList[index2].SettingHierarchy]}(${ThousandSeparator(settingList[index2].FSV, (data2.GPI === 4 || data2.GPI === 139) ? 0 : (CheckIsThousandCurrency(data2.CS,this) ? 3 : 2))})`"
                                                                           required                                                                           
                                                                           :value="(settingList[index2].SV === '' || settingList[index2].SV === null) ? '' : ThousandSeparator(settingList[index2].SV, (data2.GPI === 4 || data2.GPI === 139) ? 0 : (CheckIsThousandCurrency(data2.CS,this) ? 3 : 2))"
                                                                           @change="event => { settingList[index2].SV = RemoveThousandSeparator(event.target.value, (data2.GPI === 4 || data2.GPI === 139) ? 0 : (CheckIsThousandCurrency(data2.CS,this) ? 3 : 2)) }"
                                                                           min="0.0" step="0.1" />
                                                                    <span class="col-sm-6 offset-sm-6 ErrMsg">{{ValidationErrMsg(data2.GPI,index2)}}</span>
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </template>



                        <CCol col="12" v-if="!noData && checkModuleAccess3(constAccessType.edit)">
                            <CButton class='searchBtn float-right' size="sm" color="info" @click="SaveSetting()"><span>{{this.getLanguage["BTN"]["SV"]}}</span></CButton>
                        </CCol>
                    </CRow>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                rendering: true,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                timeout: null,
                ddAgentList: null,
                searchAgi: null,
                searchAgent: null,
                searchOutlet: null,
                rtSubBrand: 0,
                ddMemberTypeList: null,
                searchMemberType: null,
                disableMemDD: false,
                disableSubDD: false,
                noData: true,
                settingList: [],
                dd_gp_currency: [],
                //onOffOptionList: [],
                afbSports: [{
                    id: 0,
                    label: 'ALL',
                    children: [
                        { "id": 1, "label": "Soccer" },
                        { "id": 2, "label": "Basketball" },
                        { "id": 3, "label": "Tennis" },
                        { "id": 4, "label": "Financials" },
                        { "id": 5, "label": "4DSpecials" },
                        { "id": 7, "label": "Olympic" },
                        { "id": 8, "label": "USFootball" },
                        { "id": 9, "label": "Baseball" },
                        { "id": 10, "label": "IceHockey" },
                        { "id": 11, "label": "Snooker" },
                        { "id": 12, "label": "Rugby" },
                        { "id": 13, "label": "Darts" },
                        { "id": 14, "label": "Boxing" },
                        { "id": 15, "label": "Formula1" },
                        { "id": 16, "label": "MotorSports" },
                        { "id": 17, "label": "Golf" },
                        { "id": 18, "label": "Pool" },
                        { "id": 19, "label": "Futsal" },
                        { "id": 20, "label": "Badminton" },
                        { "id": 21, "label": "WaterPolo" },
                        { "id": 22, "label": "TableTennis" },
                        { "id": 23, "label": "Cricket" },
                        { "id": 24, "label": "Volleyball" },
                        { "id": 25, "label": "Handball" },
                        { "id": 26, "label": "Cycling" },
                        { "id": 27, "label": "BeachSoccer" },
                        { "id": 29, "label": "Athletics" },
                        { "id": 30, "label": "WinterSport" },
                        { "id": 31, "label": "Squash" },
                        { "id": 33, "label": "HuayThai" },
                        { "id": 34, "label": "ESports" },
                        { "id": 35, "label": "MuayThai" },
                        { "id": 36, "label": "EUROPE VIEW" }
                    ]
                }],
                selectedSports: {},
                settingTitle: null,
                totalNetWinning: null,
                regexInt: new RegExp("^[0-9]+$"),
                regexDecimal: new RegExp("^[0-9]+[\.]?[0-9]*$"),
                arr_displayGCI: [],
                arr_displayGPI: [],
                arr_currencies: [],
                ddDefaultSubBrand: [],
                dd_subagentgroup: [], //get outlet
                constAccessType: constAccessType,
                selectedGP: 0,
                selectedISOC: 0,
            }
        },
        validations: {
            settingList: {
                $each: {
                    SV: {                        
                        decimal: (function (value, obj) {
                            if (value && (obj.SVT == 0 || obj.SVT == 2)) {
                                return this.regexDecimal.test(value);
                            }
                            return true;
                        })
                    }
                }
            }
        },
        computed: {
            ...mapGetters('UserInfo', ['checkModuleAccess']),
        },
        methods: {
            ...mapGetters('UserInfo', ['getUserInfo']),
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgi) {
                    parentAGI = this.searchAgi;
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/outletonly/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/outletonly/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchOutlet = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            DisplayGCI(gci) {
                if (this.arr_displayGCI.includes(gci)) {
                    this.arr_displayGCI.splice(this.arr_displayGCI.indexOf(gci), 1);
                } else {
                    this.arr_displayGCI.push(gci);
                }
            },
            DisplayGPI(gpi) {
                if (this.arr_displayGPI.includes(gpi)) {
                    this.arr_displayGPI.splice(this.arr_displayGPI.indexOf(gpi), 1);
                } else {
                    this.arr_displayGPI.push(gpi);
                }
            },
            GetAgentLabel(value, agentList) {
                var agentLabel = null;
                if (agentList && agentList.length > 0) {
                    for (var i = 0; i < agentList.length; i++) {
                        if (agentList[i].id == value) {
                            agentLabel = agentList[i].label;
                            break;
                        }
                        else if (agentList[i].children) {
                            agentLabel = this.GetAgentLabel(value, agentList[i].children);

                            if (agentLabel) {
                                break;
                            }
                        }
                    }
                }

                return agentLabel;
            },
            GetSetting() {
                let that = this;
                that.rendering = true;
                that.bool_fullLoading = true;
                that.settingTitle = '';
                that.settingList = null;

                if (that.getUserInfo().AT != 0) {
                    if (!that.searchAgi) {
                        that.searchAgi = that.getUserInfo().AGI;
                        that.searchAgent = "3-" + that.getUserInfo().AGI;
                    }
                }

                var agi = 0, mti = 0;
                if (that.searchAgi) {
                    agi = that.searchAgi;

                    if (that.getUserInfo().AT == 0 && that.getUserInfo().AGI == agi) {
                        agi = 0;
                    }
                    else {

                        var agentLabel = that.GetAgentLabel(that.searchAgent, that.ddAgentList);
                        if (agentLabel) {
                            that.settingTitle += ' - ' + agentLabel;
                        }
                    }
                }

                if (that.searchOutlet) {
                    agi = that.searchOutlet;

                    var agentLabel = that.GetAgentLabel(that.searchOutlet, that.dd_subagentgroup);
                    if (agentLabel) {
                        that.settingTitle += ' - ' + agentLabel;
                    }
                }

                if (that.searchMemberType) {
                    mti = that.searchMemberType;

                    if (that.ddMemberTypeList && that.ddMemberTypeList.length > 0) {
                        for (var i = 0; i < that.ddMemberTypeList.length; i++) {
                            if (that.ddMemberTypeList[i].id == that.searchMemberType) {
                                that.settingTitle += ' - ' + that.ddMemberTypeList[i].label;
                                break;
                            }
                        }
                    }
                }

                if (!agi && !mti && that.getUserInfo().AT == 0) {
                    that.settingTitle = ' - ' + this.getLanguage['GS']['SYSTEM'];
                }

                that.getDataApi(`/api/gsetting/ls/${agi}/${mti}`, function (d, s) {
                    that.noData = true;
                    that.arr_displayGCI = [];
                    that.arr_displayGPI = [];
                    that.arr_currencies = d.Item2;
                    that.totalNetWinning = d.Item3;
                    d = d.Item1;
                    if (s && d && d.length) {
                        that.noData = false;
                        if (d.length > 0) {
                            var prevCategoryId = null;
                            var prevProviderId = null;
                            var prevCurrencyId = null;

                            that.dd_gp_currency = _.groupBy(d, 'PN');
                            for (var key in that.dd_gp_currency) {
                                if (key != 'null') {
                                    if (that.arr_currencies.length > 0) {
                                        var filterData = [];
                                        for (var x = 0; x < that.dd_gp_currency[key].length; x++) {
                                            if (that.arr_currencies.includes(that.dd_gp_currency[key][x]['CI'])) {
                                                filterData.push(that.dd_gp_currency[key][x]);
                                            }
                                        }
                                        that.dd_gp_currency[key] = _.compact(_.uniq(_.map(filterData, 'ISOC')));
                                    } else {
                                        that.dd_gp_currency[key] = _.compact(_.uniq(_.map(that.dd_gp_currency[key], 'ISOC')));
                                    }
                                }
                            }

                            for (var i = 0; i < d.length; i++) {
                                if (prevCategoryId == d[i].GCI) {
                                    d[i].CN = null;
                                }

                                prevCategoryId = d[i].GCI;

                                if (prevProviderId == d[i].GPI && prevCurrencyId == d[i].CI) {
                                    d[i].PN = null;
                                }

                                prevProviderId = d[i].GPI;

                                if (prevCurrencyId == d[i].CI) {
                                    d[i].DFFC = false;
                                }
                                else {
                                    d[i].DFFC = true;
                                }

                                prevCurrencyId = d[i].CI;

                                if (d[i].SVT == 1 && !d[i].SV) {
                                    d[i].SV = null;
                                }

                                if (d[i].SN === 'AfbSports') {
                                    let sportData = null;
                                    if (d[i].SV && d[i].SV.trim() !== '') {
                                        const dbSports = d[i].SV.split(',').map(Number);
                                        for (let j = 0; j < that.afbSports[0].children.length; j++) {
                                            let child = that.afbSports[0].children[j];
                                            //if doesnt include any one of ids, it means not all sports are selected to dbSports.
                                            if (!dbSports.includes(child.id)) {
                                                sportData = {
                                                    idx: i,
                                                    selections: dbSports
                                                };
                                                break;
                                            }

                                            //if dbSports include all, then change its value to 0.
                                            if (j === that.afbSports[0].children.length - 1) {
                                                sportData = {
                                                    idx: i,
                                                    selections: [0]
                                                };
                                            }
                                        }
                                        //no value, shows all.
                                    } else {
                                        sportData = {
                                            idx: i,
                                            selections: [0]
                                        }
                                    }

                                    that.selectedSports[d[i].GPI] = sportData;
                                }                                                                
                            }
                        }
                        that.settingList = d;
                        
                        setTimeout(() => {
                            $("#GSDU .table-wrapper .row .section-title2").each(function (index) {
                                $(this).find('span').html(index + 1);
                            });
                        }, 500)
                    }

                    that.bool_fullLoading = false;
                    that.rendering = false;
                });
            },
            onAfbSportsChanged(sportIds) {
                if (sportIds.includes(0)) {

                }
                const selectedSport = this.selectedSports[data.GPI];
                if (!selectedSport) {
                    return;
                }
                //selectedSport.
            },
            RenderSettingName(settingName, providerId) {
                if (providerId == 4 && ((settingName == "Min" && "MINS" in this.getLanguage['GS'])
                    || (settingName == "Max" && "MAXS" in this.getLanguage['GS']))) {
                    return this.getLanguage['GS'][settingName.toUpperCase() + "S"];
                }
                else if (settingName && settingName.toUpperCase() in this.getLanguage['GS']) {
                    return this.getLanguage['GS'][settingName.toUpperCase()];
                }
                else {
                    return settingName;
                }
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            TickCheckbox(event, data) {
                var val = 0;
                if (event.target.checked) {
                    val = 1;
                }

                data.SV = val;
            },
            SaveSetting() {
                this.$v.settingList.$touch();
                if (!this.$v.settingList.$error) {
                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    //handle sportList for AFB1188
                    for (const [key, value] of Object.entries(this.selectedSports)) {
                        let sportsText = null;
                        if (!value.selections || value.selections.length === 0) {
                            //should suspend and return an error message here
                        } else if (value.selections.includes(0)) {
                            this.afbSports[0].children.forEach((o, idx) => {
                                sportsText += o.id;
                                if (idx !== this.afbSports[0].children.length - 1) {
                                    sportsText += ",";
                                }
                            });
                        } else {
                            sportsText = value.selections.join(',');
                        }
                        this.settingList[value.idx].SV = sportsText
                    }

                    this.postDataApi(`/api/gsetting/ss`, this.settingList,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.GetSetting();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                }                
            },
            selectAgentOptions(value, instanceId) {
                this.searchAgi = 0;
                this.ddMemberTypeList = null;
                this.searchMemberType = null;
                this.rendering = true;

                if (value) {
                    var agentList = value.split("-");
                    this.searchAgi = agentList[agentList.length - 1];
                    this.searchOutlet = null;

                    if (this.getUserInfo().AT == 0 && this.getUserInfo().AGI == this.searchAgi) {
                        this.disableMemDD = true;
                        this.disableSubDD = true;
                    } else {
                        this.disableMemDD = false;
                        this.disableSubDD = false;
                    }
                } else {
                    this.searchOutlet = null;
                }
            },
            selectOutletOptions(value) {
                this.rendering = true;

                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.searchOutlet = agi;
                    }
                }
                else {
                    this.searchOutlet = null;
                }
            },
            selectMemberType(value, instanceId) {
                this.rendering = true;
            },
            loadMemberTypeOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.searchAgi) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    this.getDataApi(`/api/dd/mType/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberTypeList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberTypeList = null;
                            }

                            callback();
                        });
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SUB', 'AGS', type);
            },
            checkModuleAccess3(type) {
                return this.checkModuleAccess('GSDU', 'GS', type);
            },
            ValidationErrMsg(gpi,index) {
                var errObj = this.$v.settingList.$each.$iter[index].SV;
                if (!errObj.decimal) {
                    if (gpi === 4 || gpi === 139) {
                        return String.format(this.getLanguage['ERR']['1009'], this.getLanguage['GS']['VAL']);
                    }
                    else {
                        return String.format(this.getLanguage['ERR']['1007'], this.getLanguage['GS']['VAL']);
                    }                    
                }
                return null;                
            },           
        },
        watch: {
            getLanguage() {
                this.GetSetting();
                this.onOffOptionList = [{ id: '0', label: this.getLanguage['GS']['OFF'] }, { id: '1', label: this.getLanguage['GS']['ON'] }];

            },
        },
        created() {
            this.$parent.showSubMenu = 'GS';
            this.$parent.showActiveMenu = 'GS.GSDU';
            this.onOffOptionList = [{ id: '0', label: this.getLanguage['GS']['OFF'] }, { id: '1', label: this.getLanguage['GS']['ON'] }];
            if (this.getUserInfo().AT != 0) {
                this.searchAgi = this.getUserInfo().AGI;
                this.searchAgent = "3-" + this.getUserInfo().AGI;
            }

            if (this.getUserInfo().AT == 4) {
                this.loadDefaultSubBrand(0);
            }
            if (this.$route.query.agi) {
                var agi = this.$route.query.agi.split("-");
                this.searchAgi = agi[1];
                this.searchAgent = this.$route.query.agi;
                this.GetSetting();
            }
            // this.GetSetting();            
        }

    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/GameSettings/GameSettings.vue